import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { IMAGE_SRC } from '../shared/shared-constants';
import {
  BANNER,
  BANNER_MESSAGE_TYPE,
  FILE_UPLOAD_RESPONSE,
} from './banner.constants';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  standalone: false,
})
export class BannerComponent {
  @Input() drawerOpen!: boolean;
  @Output() emitExit = new EventEmitter();

  readonly IMAGES = IMAGE_SRC;
  readonly BANNER_TYPE = BANNER;
  readonly BANNER_MESSAGE_TYPE = BANNER_MESSAGE_TYPE;
  readonly BANNER_400_MESSAGE = this.commonUtils.unknownBannerText;
  readonly bannerType = this.commonUtils.bannerType;
  readonly FILE_UPLOAD_RESPONSE = FILE_UPLOAD_RESPONSE;

  constructor(public readonly commonUtils: CommonUtils) {}

  clickExit() {
    //Reset file upload banner on close
    this.commonUtils.fileUploadResponse.set({
      uniqueUploadId: '',
      fileName: '',
      fileSize: 0,
      accepted: 0,
      rejected: [],
      received: 0,
      itemsNonProcessed: [],
    });
    this.emitExit.emit();
  }

  isRejectedDueToInspectArray(): boolean {
    return !!this.commonUtils.fileUploadResponse().rejectedDueToInspect;
  }
}
